<!-- @format -->

<template>
	<disabled-text v-if="disabled && showDisabledText" :value="value" :params="params" />
	<el-checkbox-group v-else v-model="value" :disabled="disabled">
		<template v-if="isButton">
			<el-checkbox-button
				v-for="item in params"
				:key="item.value"
				:label="item.value"
				:border="border"
				v-bind="getExtraAttrs(item)"
			>
				{{ item.label }}
			</el-checkbox-button>
		</template>
		<template v-else>
			<el-checkbox
				v-for="item in params"
				:key="item.value"
				:label="item.value"
				:border="border"
				v-bind="getExtraAttrs(item)"
			>
				{{ item.label }}
			</el-checkbox>
		</template>
	</el-checkbox-group>
</template>

<script setup lang="ts">
	import DisabledText from './disabledText.vue';

	interface Props {
		modelValue: string;
		border?: boolean;
		isButton?: boolean;
		params: {
			label: string;
			value: string;
			[key: string]: any;
		}[];
		disabled?: boolean;
		showDisabledText?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
		showDisabledText: true,
	});

	const getExtraAttrs = (item: any) => {
		const { label: _label, value: _value, ...rest } = item;
		return rest;
	};

	const emit = defineEmits(['update:modelValue']);

	// 后端存的是字符串，需要调整为数组
	const value = computed({
		get() {
			return props.modelValue ? props.modelValue?.split(',') : [];
		},
		set(val) {
			emit('update:modelValue', val.join(','));
		},
	});
</script>

<style scoped>
	.show-value {
		display: flex;
		gap: 3px;
		flex-wrap: wrap;
	}
</style>
